import React from 'react'

const PageLayoutContentOnly = ({ children }) => <>{children}</>

export default PageLayoutContentOnly
